var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ds-save-bar"},[(_vm.$slots.status)?_c('div',{staticClass:"ds-save-bar-status"},[_vm._t("status")],2):_vm._e(),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }